import { ReactNode, FC } from 'react';
import { Stack, BodyText } from '@servicetitan/design-system';
import classNames from 'classnames';
import * as Style from './display-info-styles.module.less';

export interface DisplayInfoProps {
    title: string;
    body?: ReactNode;
    className?: string;
}

export const DisplayInfo: FC<DisplayInfoProps> = ({ title, body, className }) => {
    return (
        <Stack className={classNames(Style.displayInfo, 'p-r-2', className)} direction="column">
            <BodyText subdued className="fs-1-i m-b-half-i">
                {title.toUpperCase()}
            </BodyText>
            <BodyText el="div">{body}</BodyText>
        </Stack>
    );
};

export interface YesNoDisplayInfoProps extends Omit<DisplayInfoProps, 'body'> {
    value: boolean;
}

export const YesNoDisplayInfo: FC<YesNoDisplayInfoProps> = ({ value, ...props }) => (
    <DisplayInfo body={value ? 'Yes' : 'No'} {...props} />
);
